import React, {Component} from 'react';
import {Link} from 'react-router-dom';

const FooterTop = (props) => {

  return (
    <div className="footer-top">
      <div className="container">
        <div className="row">
          <div className="col-md-3 col-sm-6">
            <div className="left-container">
              <div className="nav-title grayed">PAYMENT METHODS</div>
              <div className="icons-container">
                <i className="fa fa-cc-visa payment-icon"/>
                <i className="fa fa-cc-amex payment-icon"/>
                <i className="fa fa-cc-paypal payment-icon"/>
                <i className="fa fa-cc-mastercard payment-icon"/>
                <i className="fa fa-cc-dinners-club payment-icon"/>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mobile-footer-top-right">
            <div className="right-container">
              <div className="nav-title grayed">DELIVERY METHODS</div>
              <div className="icons-container">
                <i className="fa fa-motorcycle delivery-methods-icon"/>
                <i className="fa fa-truck delivery-methods-icon"/>
                <i className="fa fa-shopping-basket delivery-methods-icon"/>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
          </div>
          <div className="col-md-3 desktop-footer-top-right">
            <div className="right-container">
              <div className="nav-title grayed">DELIVERY METHODS</div>
              <div className="icons-container">
                <i className="fa fa-motorcycle delivery-methods-icon"/>
                <i className="fa fa-truck delivery-methods-icon"/>
                <i className="fa fa-shopping-basket delivery-methods-icon"/>
              </div>
            </div>
          </div>
        </div>
        <div className="divider"></div>
      </div>
    </div>
  )
}

export default FooterTop;



// WEBPACK FOOTER //
// ./src/components/commons/footer/FooterTop.js